"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class HealthCheckService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'health-check';
        this.invoke = async (action, data) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const input = JSON.stringify(Object.assign(Object.assign({}, data), { action, env: this.ENV }));
            const body = {
                "input": input,
                "name": "HealthCheckExecution",
                "stateMachineArn": "arn:aws:states:us-west-2:031182997863:stateMachine:HealthCheck"
            };
            const response = await axios_1.default.post(URL, JSON.stringify(body), {
                headers: {
                    'x-api-key': this.KEY,
                }
            });
            if (response.status === 200) {
                let data = null;
                if (response.data) {
                    if (response.data.output) {
                        const output = JSON.parse(response.data.output);
                        if (output.body) {
                            data = JSON.parse(output.body);
                        }
                    }
                }
                return Promise.resolve(data);
            }
            else {
                return Promise.reject(response.statusText);
            }
        };
        this.updatePrincipalEmail = async (usrData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/healthcheck/email-update`;
            const response = await axios_1.default.post(URL, JSON.stringify(usrData), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.HealthCheckService = HealthCheckService;
